module.exports = __webpack_public_path__ + "static/media/copy.e4fce489.svg";